import React, { useEffect } from "react";
import styled from "styled-components";
import Banner from "../components/homeComponents/Banner";
import Products from "./Products";
import Stats from "../components/homeComponents/Stats";
import FAQ from "../components/homeComponents/FAQ";
import ContactPage from "./ContactPage";
import Categories from "../components/homeComponents/Categories";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Premium Perfume KS";
  }, []);
  return (
    <Container>
      <Banner />
      <Categories />
      {/* <Products /> */}
      <Stats />
      <FAQ />
      <ContactPage />
    </Container>
  );
};
const Container = styled.div`
  overflow: hidden;
`;

export default Home;
